import { useEffect, useState } from "react";

/**
 * Returns false during SSR and the initial client render, true after mount.
 * State-based (not a ref) so consumers re-render when the value flips —
 * a ref read during render would stay stale until some other re-render.
 */
export const useIsMounted = () => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return isMounted;
};
